import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  disableLoading,
  setMetaInfo,
  setProperties,
  enableLoading,
  setFilter,
} from '../actions'
import axios from 'axios'

const useFetchProperties = (operationId) => {
  const dispatch = useDispatch()

  const { url, urlSearch, loading, properties } = useSelector((state) => ({
    url: state.properties.url,
    urlSearch: state.properties.urlSearch,
    loading: state.properties.loading,
    properties: state.properties.properties,
  }))

  useEffect(() => {
    let isMounted = true

    const finishLoading = () => {
      if (isMounted) {
        dispatch(disableLoading())
      }
    }

    const fetchAll = async () => {
      if (!url) {
        finishLoading()
        return
      }

      try {
        const requestUrl = `${url}`
        localStorage.setItem('fetchUrl', requestUrl)
        const { data } = await axios.get(requestUrl)
        if (!isMounted) return
        const { objects, meta } = data
        dispatch(setProperties(objects))
        dispatch(setMetaInfo(meta))
      } catch (error) {
        if (isMounted) {
          console.error('FETCHING PROPERTIES: ', error)
          dispatch(setProperties([]))
        }
      } finally {
        finishLoading()
      }
    }

    const fetchFiltered = async () => {
      if (!urlSearch || typeof operationId !== 'string') {
        fetchAll()
        return
      }

      dispatch(setFilter({ id: operationId, filter: 'operation_type' }))

      const params = {
        price_from: 0,
        price_to: 99999999,
        operation_types: [operationId],
        property_types: [1, 2, 3, 4, 5, 6, 7, 8],
      }

      try {
        const requestUrl = `${urlSearch}&data=${JSON.stringify(params)}`
        localStorage.setItem('fetchUrl', requestUrl)
        const { data } = await axios.get(requestUrl)
        if (!isMounted) return
        dispatch(setProperties(data.objects))
        dispatch(setMetaInfo(data.meta))
      } catch (error) {
        if (isMounted) {
          console.error('FETCHING PROPERTIES: ', error)
          dispatch(setProperties([]))
        }
      } finally {
        finishLoading()
      }
    }

    dispatch(enableLoading())
    dispatch(setProperties([]))

    if (typeof operationId === 'string' && operationId.length > 0) {
      fetchFiltered()
    } else {
      fetchAll()
    }

    return () => {
      isMounted = false
    }
  }, [dispatch, operationId, url, urlSearch])

  return {
    properties,
    loading,
  }
}

export default useFetchProperties
